import { DateRange } from "react-day-picker";

import { OrganizationUsageTotal } from "@/types/organization-usage";

export const USAGE_TYPE_KEYS = {
  evalCells: "eval_cells",
  agents: "workflow_nodes",
  playgroundRuns: "playground_runs",
  requestLogs: "request_logs",
  traces: "traces",
} as const;

export type UsageTypeKey = keyof typeof USAGE_TYPE_KEYS;

export interface UsageType {
  key: UsageTypeKey;
  title: string;
  description: string;
  limit?: number | string;
}

export interface UsageLimits {
  evaluations?: number | string;
  agents?: number | string;
  prompts?: number | string;
  playgroundRuns?: number | string;
  requestLogs?: number | string;
  traces?: number | string;
}

export type ProcessedWorkspaceData = Record<string, ProcessedUsageItem[]>;

export interface ProcessedUsageItem {
  [key: string]: number | string | boolean | null;
  rawDatetime: string;
  datetime: string;
  isProjected: boolean;
}

export type WorkspaceInfo = Record<string, string>;

export interface ProcessedData {
  evalCells: ProcessedWorkspaceData;
  agents: ProcessedWorkspaceData;
  playgroundRuns: ProcessedWorkspaceData;
  requestLogs: ProcessedWorkspaceData;
  traces: ProcessedWorkspaceData;
  workspaceInfo: WorkspaceInfo;
}

export interface ChartDataPoint {
  datetime: string;
  rawDatetime: string;
  isProjected: boolean;
  [workspaceName: string]: number | string | boolean | null;
}

export interface LimitBadgeProps {
  isOverLimit: boolean;
  limit: number | string;
  projectedPrice: number;
  isLoading: boolean;
  total: number;
}

export interface ChartWrapperProps {
  title: string;
  description: string;
  usageType: UsageType;
  processedData: ProcessedData;
  className?: string;
  isLoading: boolean;
  totalOrganizationUsage?: OrganizationUsageTotal;
  projectedTotalOrganizationUsage?: OrganizationUsageTotal;
}

export interface FiltersProps {
  dateRange: DateRange | undefined;
  setDateRange: (dateRange: DateRange | undefined) => void;
  selectedWorkspaceIds: number[];
  filtersOpen: boolean;
  setFiltersOpen: (open: boolean) => void;
}

export interface UsageChartsState {
  dateRange: DateRange | undefined;
  selectedWorkspaceIds: number[];
  filtersOpen: boolean;
}
